import { render, staticRenderFns } from "./TicketTypeAdd.vue?vue&type=template&id=7c2e713e&"
import script from "./TicketTypeAdd.vue?vue&type=script&lang=js&"
export * from "./TicketTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports